const detectLocation = (ltd, lotd) => {
    // Fungsi untuk menghitung jarak menggunakan rumus Haversine
    const haversineDistance = (lat1, lon1, lat2, lon2) => {
        const R = 6371000; // Jari-jari Bumi dalam meter
        const toRad = (value) => (value * Math.PI) / 180;

        const deltaLat = toRad(lat2 - lat1);
        const deltaLon = toRad(lon2 - lon1);

        const a =
            Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
            Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
            Math.sin(deltaLon / 2) * Math.sin(deltaLon / 2);

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const distance = R * c; // Jarak dalam meter

        return distance;
    };

    // Fungsi untuk memeriksa apakah pengguna berada dalam radius tertentu
    const isWithinRadius = (userLat, userLon, targetLat, targetLon, radiusInMeters = 100) => {
        const distance = haversineDistance(userLat, userLon, targetLat, targetLon);
        return distance <= radiusInMeters;
    };
    
    // navigator.geolocation.getCurrentPosition

    // Contoh penggunaan
    const userLocation = { lat: ltd, lon: lotd }; // Koordinat pengguna
    const targetLocation = { lat: -7.827772593470757, lon: 112.03167615629707 }; // Koordinat lokasi target

    const result = isWithinRadius(userLocation.lat, userLocation.lon, targetLocation.lat, targetLocation.lon);
    return result


};

export default detectLocation;
